type SortMappingType = {
  [key: string]: {
    field: string;
    order: string;
  }
};

type SortDisplayMappingType = {
  [key: string]: {
    display_option: string;
    order: string;
  }
};

export const displayOptions = [
  { value: 'all', label: 'すべてのページ' },
  { value: 'published', label: '公開中のみ' },
  { value: 'not_published', label: '非公開のみ' },
];

export const sortOptions = [
  { value: 'updated_at_newer', label: '編集日が新しい' },
  { value: 'updated_at_older', label: '編集日が古い' },
  { value: 'created_at_newer', label: '作成日が新しい' },
  { value: 'created_at_older', label: '作成日が古い' },
  { value: 'title', label: 'タイトル順' },
];

export const sortMapping: SortMappingType = {
  updated_at_newer: { field: 'updated_at', order: 'desc' },
  updated_at_older: { field: 'updated_at', order: 'asc' },
  created_at_newer: { field: 'created_at', order: 'desc' },
  created_at_older: { field: 'created_at', order: 'asc' },
  title: { field: 'title', order: 'asc' },
};

export const sortDisplayMapping: SortDisplayMappingType = {
  all: { display_option: 'all', order: 'desc' },
  published: { display_option: 'published', order: 'desc' },
  not_published: { display_option: 'not_published', order: 'desc' },
};
